import React, { useState, useEffect } from "react";
import { Column, TotalItem, Summary, HeaderFilter, FilterRow, FilterPanel } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";
import ComboAbmEexProveedores from "../../../Componentes/Compuestos/Combos/ComboAbmEexProveedores";
import { Navigate } from "react-router-dom";

export const CON_Reporte_Proveedor = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [IdProveedor, setIdProveedor] = useState("")
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const [FechaDesde, setFechaDesde] = useState(new Date(DiasParaDesdeListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaDesdeListados) : Date.now()));
  const [FechaHasta, setFechaHasta] = useState(new Date(DiasParaHastaListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaHastaListados) : Date.now()));
  const { CONT_Reportes: { function_CONT_Reportes_ProveedorConSaldo } } = require('neftis7_apicaller');

  const onValueChangedFechaDesde = (nuevaFecha) => {
    setFechaDesde(nuevaFecha.value);
  };

  const onValueChangedFechaHasta = (nuevaFecha) => {
    setFechaHasta(nuevaFecha.value);
  };

  const onValueChangedIdProveedor = (nuevoCodigo) => {
    setIdProveedor(nuevoCodigo.value);
  };

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      if (IdProveedor && IdProveedor > 0) {
        let resultData = await function_CONT_Reportes_ProveedorConSaldo(IdProveedor);

        setData(resultData.data)
      }
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta, IdProveedor]); // Llamar a getData cuando FechaDesde o FechaHasta cambien

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      };
    }
  }, []);

  return (
    <PaginaReporte
      Titulo="CUENTA CORRIENTE PROVEEDOR"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>
                <td width={120}>
                  
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={onValueChangedFechaDesde} visible={false}/>
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={onValueChangedFechaHasta} visible={false}/>
                </td>
                <td width={130}>
                  <ComboAbmEexProveedores onValueChanged={onValueChangedIdProveedor} ancho="500" />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={data}
                id="gridContainer"
              >
                <HeaderFilter visible={false} />
                <FilterPanel visible={false} />
                <FilterRow visible={false} />
                <Summary>
                  <TotalItem
                    column="Id"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                </Summary>

                <Column caption="Operación" dataField="Id" width="120" alignment="Right" dataType="number" allowSorting={false} />
                <Column caption="Tipo" dataField="Tipo" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} allowSorting={false} />

                <Column caption="Proveedor" alignment="Center" >
                  <Column caption="Código" dataField="IdProveedor" width="70" alignment="Right" dataType="number" allowSorting={false} />
                  <Column caption="Descripción" dataField="ABM_EEX_Proveedores_RazonSocial" width="200" alignment="Left" dataType="string" allowSorting={false} />
                </Column>
                <Column caption="Documento" dataField="NumeroFantasia" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Concepto" dataField="Concepto" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Observaciones" dataField="Observaciones" width="200" alignment="Left" dataType="string" allowSorting={false} />

                <Column caption="Importes" alignment="Center">
                  <Column caption="Debe" dataField="Haber" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                  <Column caption="Haber" dataField="Debe" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                  <Column caption="Saldo" dataField="Saldo" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                </Column>

              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaReporte>
  );
};
